module.exports = __webpack_public_path__ + "images/sgp/5x5/amenities.webp";